import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitEltDocuments = createSelector(
  selectFinancialCockpitState,
  ({ eltDocuments }) => eltDocuments
)
